'use client';

import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import ClearRoundedIcon from '@mui/icons-material/ClearRounded';
import { colors } from '../../theme/color';
import { LoadingIconCoupon } from '../loading/LoadingIconCoupon';
import useIsMounted from '../../hooks/useIsMounted';

type Props = {
  onClick: () => Promise<unknown>;
  className?: string;
};

export const XButton: React.FC<Props> = ({ onClick, ...props }) => {
  const [loading, setLoading] = useState<boolean>(false);

  const isMounted = useIsMounted();

  const handleClick = useCallback(async () => {
    try {
      setLoading(true);
      await onClick();
      if (isMounted()) setLoading(false);
    } catch (e) {
      if (isMounted()) setLoading(false);
      throw e;
    }
  }, [isMounted, onClick]);

  return (
    <StyledButton onClick={handleClick} disabled={loading} {...props}>
      {loading ? <LoadingIconCoupon /> : <CloseIcon fontSize="medium" />}
    </StyledButton>
  );
};

const StyledButton = styled.button`
  padding: 0 0 10px 10px;
  background: none;
  border: 0;

  & svg {
    transition: all 0.1s;
  }

  &:hover {
    & svg {
      color: ${colors.green.base};
    }
  }

  &:focus {
    outline: 0;
  }

  &:focus-visible {
    & svg {
      outline: 2px solid ${colors.green.base};
    }
  }
`;

const CloseIcon = styled(ClearRoundedIcon)`
  border-radius: 4px;
  color: ${colors.green.darker(50)};
`;
